// extracted by mini-css-extract-plugin
export default {"label":"Cluster__label___S2WSV"};